export const IMAGE_FALLBACK_SIZE_TO_CONTAINER_SIZE = 0.82;
export const PLUS_ICON_SIZE_TO_CONTAINER_SIZE = 0.01363698;
export const PLUS_ICON_SIZE_DEFAULT = 2;
